import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../providers/AuthContext";
import Login from "../../Auth/LoginPage";
import clsx from "clsx";

const GameCard = ({ game, type }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  const gameLauncher = (selectedGame) => {
    console.log(selectedGame, "selectedGame");
    navigate(
      `/game-play/${selectedGame.gameId}${selectedGame.name && "?name=" + selectedGame.name}${type && "&type=" + type}${
        selectedGame.vendorid ? "&provider=" + selectedGame.vendorid : ""
      }`
    );
  };
  return (
    <>
      <div
        key={game._id}
        className="game-card relative bg-[#313346] p-2 rounded-md overflow-hidden shadow-lg hover:shadow-2xl"
        onClick={() => (user ? gameLauncher(game) : setIsLoginOpen(true))}
      >
        <div
          className="rounded-md overflow-hidden"
          style={{
            aspectRatio: 1,
          }}
        >
          <img
            src={game.iconurl2 ? game.iconurl2 : game.image_square}
            alt={game.name}
            className={clsx("w-full h-auto", game.iconurl2 ? "h-full" : "h-auto")}
          />
        </div>
        <p className="text-white uppercase text-center m-0 text-[.75rem] pt-1 font-normal">{game?.name}</p>
        <div className="overlay absolute inset-0 bg-[#575c75] bg-opacity-60 hidden md:flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity gap-1">
          <button
            className="bg-primary px-3 py-1.5 rounded-md text-white font-bold shadow-lg transition [&_svg_path]:fill-primary"
            onClick={() => (user ? gameLauncher(game.gameId || game.gameid) : setIsLoginOpen(true))}
          >
            {user ? "Play" : "Log in & play"}
          </button>
        </div>
      </div>
      {isLoginOpen && <Login isOpen={isLoginOpen} setIsOpen={setIsLoginOpen} />}
    </>
  );
};

export default GameCard;
